import React from 'react';

// eslint-disable-next-line max-len
const RIGHTLANDER_LOGO = '/themes/theme/rightlander/rightlander-logo.png';
const RIGHTLANDER_DARK_LOGO = '/themes/theme/rightlander/rightlander-dark-logo.png';

const RightlanderTheme = {
  headerLogo: {
    src: RIGHTLANDER_LOGO,
    alt: 'Rightlander Logo',
    size: 40,
  },
  darkLogo: {
    src: RIGHTLANDER_DARK_LOGO,
    alt: 'Rightlander Logo',
    size: 40,
  },
  linkStyle: {
    color: '#fff',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#0057bc',
    borderBottom: '4px solid #0057bc',
    height: 80,
  },
  title: 'Rightlander',
  isLightOnDark: true,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="50"
        src={RIGHTLANDER_DARK_LOGO} alt="Rightlander Logo"
      />
      <br /><br />
      {/* <h3>FLYT</h3> */}
    </div>
  ),
  shareSite: 'https://rightlanderr.dyzio.co',
};

export default RightlanderTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/rightlander.js
 **/